import { ListItem } from '@components';
import { Container, Icon, Input, Typography } from '@design-system';
import { EcsModule, LibraryResponse, useGetLibraryMutation } from '@services';
import React, { useEffect, useState } from 'react';
import { BibliothequeSkeleton } from './BibliothequeSkeleton';
import { pdfjs } from 'react-pdf';

import { FaRegFilePdf } from 'react-icons/fa6';
import { GrDownload } from 'react-icons/gr';

export type BibliothequePageProps = {
    type: EcsModule;
};

pdfjs.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.mjs', import.meta.url).toString();

export const BibliothequePage: React.FC<BibliothequePageProps> = ({ type }) => {
    const [files, setFiles] = useState<LibraryResponse>([]);
    const [filteredFiles, setFilteredFiles] = useState<LibraryResponse>([]);
    const [search, setSearch] = useState<string>('');

    const [getLibrary, { data, isLoading }] = useGetLibraryMutation();

    useEffect(() => {
        getLibrary({ type });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (data) {
            setFiles(data);
            setFilteredFiles(data);
        }
    }, [data]);

    useEffect(() => {
        setFilteredFiles(files.filter((file) => file.title.toLowerCase().includes(search.toLowerCase())));
    }, [search, files]);

    return (
        <Container>
            <div style={{ position: 'sticky', top: 0, zIndex: 10, backgroundColor: '#fff', paddingBottom: '8px' }}>
                <Input
                    label="Rechercher un document"
                    value={search}
                    onValueChange={setSearch}
                    placeholder="Nom du document"
                    disabled={isLoading}
                />
            </div>

            {isLoading && <BibliothequeSkeleton />}
            {!isLoading && filteredFiles.length === 0 && (
                <Container center padding="large">
                    <Typography intrinsic="p" variant="secondary" color="grey">
                        {search ? 'Aucun document ne correspond à votre recherche' : 'Aucun document disponible'}
                    </Typography>
                </Container>
            )}
            {!isLoading &&
                filteredFiles.map(({ id, title, file, date_create }) => (
                    <a href={file} target="_blank" rel="noopener noreferrer" key={id}>
                        <ListItem
                            key={id}
                            title={title}
                            icon={<Icon icon={<FaRegFilePdf />} size={24} />}
                            date={date_create}
                            onClick={() => {
                                // No callback
                            }}
                            customRightIcon={<Icon icon={<GrDownload />} size={20} />}
                        />
                    </a>
                ))}
        </Container>
    );
};
